import { createSlice } from "@reduxjs/toolkit"
import {
  addTrainingMaterial,
  getAllTrainingMaterials,
  getTrainingMaterialDetails,
  updateTrainingMaterial,
} from "store/actions/trainingMaterialAction"
import {
  addUser,
  deleteUser,
  getAllUsers,
  getUserDetails,
  getUserLists,
  updateUser,
} from "store/actions/userAction"

const initialState = {
  loading: false,
  isLoading: false,
  isGettingDetails: false,
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  trainingMaterials: [],
  trainingMaterialDetails: {},
}

const trainingMaterialSlice = createSlice({
  name: "Training Material",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllTrainingMaterials.pending, state => {
        state.loading = true
        state.trainingMaterials = []
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getAllTrainingMaterials.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.trainingMaterials = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getAllTrainingMaterials.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(addTrainingMaterial.pending, state => {
        state.isLoading = true
      })
      .addCase(addTrainingMaterial.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addTrainingMaterial.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateTrainingMaterial.pending, state => {
        state.isLoading = true
      })
      .addCase(updateTrainingMaterial.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateTrainingMaterial.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getTrainingMaterialDetails.pending, state => {
        state.isGettingDetails = true
        state.trainingMaterialDetails = {}
      })
      .addCase(getTrainingMaterialDetails.fulfilled, (state, action) => {
        state.isGettingDetails = false
        const { success, data } = action.payload || {}
        console.log(data)
        if (success) {
          state.trainingMaterialDetails = data
        }
      })
      .addCase(getTrainingMaterialDetails.rejected, (state, action) => {
        state.isGettingDetails = false
      })

    // builder
    //   .addCase(deleteUser.pending, state => {
    //     state.isLoading = true
    //   })
    //   .addCase(deleteUser.fulfilled, (state, action) => {
    //     state.isLoading = false
    //   })
    //   .addCase(deleteUser.rejected, (state, action) => {
    //     state.isLoading = false
    //   })
  },
})

export default trainingMaterialSlice.reducer
